export class GlasContainerMarkerManager {
  constructor(map, glasContainerForm, glasContainerReturnChannelForm) {
    this.markers = [];
    this.infoWindows = [];
    this.map = map;
    this.glasContainerForm = glasContainerForm;
    this.glasContainerReturnChannelForm = glasContainerReturnChannelForm;
  }
  async addMarker(glasContainerLocation) {
    const marker = new google.maps.Marker({
      position: {lat: glasContainerLocation.latitude, lng: glasContainerLocation.longitude},
      map: this.map,
      icon: "/_assets/8422221d44f9064df921c1080333b749/Icons/glasContainerMarker.png"
    });
    const infoWindow = new google.maps.InfoWindow({
      content: this.buildInfoWindowContent(glasContainerLocation)
    });
    marker.addListener("click", () => {
      this.infoWindows.forEach((iw) => iw.close());
      infoWindow.open({anchor: marker, map: this.map, shouldFocus: false});
    });
    this.markers.push(marker);
    this.infoWindows.push(infoWindow);
  }
  clearMarkers() {
    this.markers.forEach((marker) => marker.setMap(null));
    this.markers = [];
    this.infoWindows.forEach((infoWindow) => infoWindow.close());
    this.infoWindows = [];
  }
  updateMarkersVisibility(userPosition, radius) {
    this.markers.forEach((marker) => {
      const distance = google.maps.geometry.spherical.computeDistanceBetween(marker.getPosition(), userPosition);
      if (distance <= radius) {
        marker.setMap(this.map);
      } else {
        marker.setMap(null);
      }
    });
  }
  getVisibleMarkersCount() {
    return this.markers.filter((marker) => marker.getMap() !== null).length;
  }
  buildInfoWindowContent(glasContainerLocation) {
    const infoWindowContent = document.createElement("div");
    infoWindowContent.classList.add("glas-container-locations__info-window");
    const header = document.createElement("h4");
    header.textContent = this.glasContainerForm.dataset.locationtext;
    infoWindowContent.appendChild(header);
    const address = document.createElement("p");
    address.innerHTML = `${glasContainerLocation.street}<br> ${glasContainerLocation.zip} ${glasContainerLocation.city}<br> ${glasContainerLocation.supplementLocationInfo}`;
    infoWindowContent.appendChild(address);
    if (!!this.glasContainerReturnChannelForm.returnChannelFormElement) {
      const glasContainerFormLink = document.createElement("a");
      const glasContainerFormLinktext = document.createElement("div");
      const glasContainerFormLinkReportText = document.createElement("span");
      glasContainerFormLinktext.classList.add("text-with-icon");
      glasContainerFormLinktext.style.color = "black";
      glasContainerFormLinkReportText.classList.add("color--magenta", "glas-container-locations__info-window-report-text");
      glasContainerFormLinktext.appendChild(document.createTextNode(this.glasContainerForm.dataset.notfoundtext));
      glasContainerFormLinkReportText.appendChild(document.createTextNode(this.glasContainerForm.dataset.reporttext));
      glasContainerFormLinktext.appendChild(glasContainerFormLinkReportText);
      glasContainerFormLink.appendChild(glasContainerFormLinktext);
      glasContainerFormLink.addEventListener("click", () => this.glasContainerReturnChannelForm.fillReturnChannelFormWithCurrentContainer(glasContainerLocation));
      infoWindowContent.appendChild(glasContainerFormLink);
      const newGlasContainerLink = document.createElement("a");
      const newGlasContainerLinkText = document.createElement("div");
      newGlasContainerLinkText.classList.add("text-with-icon");
      newGlasContainerLinkText.style.color = "black";
      newGlasContainerLinkText.appendChild(document.createTextNode(this.glasContainerForm.dataset.newcontainertext));
      newGlasContainerLink.appendChild(newGlasContainerLinkText);
      newGlasContainerLink.addEventListener("click", () => this.glasContainerReturnChannelForm.fillReturnChannelFormForNewLocation(glasContainerLocation));
      infoWindowContent.appendChild(newGlasContainerLink);
    }
    return infoWindowContent;
  }
}
